import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export default function ErrorSection() {
  return (
    <>
      <Text>
        예상하지 못한 에러가 발생했습니다.
        <br />
        잠시 후 다시 시도해주세요.
      </Text>
    </>
  );
}

const Text = styled.div`
  ${getFontStyle('bold150_B2')}
  padding: 30px 0;
  color: ${({ theme }) => theme.colors.gray700};
`;
